// extracted by mini-css-extract-plugin
module.exports = {"main-component":"rightArrow_main-component__P3X8j"};